import { isEmpty } from 'lodash';
import { REMOVE_VROOM_TOKEN, SET_CONTEXT, SET_VROOM_TOKEN, SET_ANONYMOUS_INFO, REMOVE_ANONYMOUS_INFO } from '../actions/type';


const initState = {
    p: '',
    name: '',
    pkgcode: '',
    email: '',
    avatar: '',
    vroomToken: '',
    anonymousInfo: {
        id: '',
        name: ''
    }
}

const token = localStorage.getItem('vroomToken')
//add token from localstorage
if (!isEmpty(token)) {
    initState.vroomToken = token
}

const contextInfo = (state = initState, action) => {
    switch (action.type) {
        case SET_CONTEXT: {
            const { payload } = action
            return { ...state, ...payload };
        }
        case SET_VROOM_TOKEN: {
            const { payload } = action
            return { ...state, ...payload };
        }
        case REMOVE_VROOM_TOKEN: {
            localStorage.removeItem('vroomToken')
            return { ...state, vroomToken: '' }
        }
        case SET_ANONYMOUS_INFO: {
            const { payload } = action
            return { ...state, ...payload };
        }
        case REMOVE_ANONYMOUS_INFO: {
            localStorage.removeItem('anonymousInfo')
            const anonymousInfo = {
                id: '',
                name: ''
            }
            return { ...state, anonymousInfo }
        }
        default:
            return state;

    }
}

export default contextInfo